function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.75 1.45a8 8 0 108.25 8 8.13 8.13 0 00-8.25-8m0 17.43a9.45 9.45 0 119.75-9.44 9.61 9.61 0 01-9.75 9.44"
});

var SvgCircle = function SvgCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 19.5 18.88"
  }, props), _ref);
};

export default SvgCircle;